const clientId = "105868";
const redirectUri = process.env.REACT_APP_STRAVA_CALLBACK_DOMAIN as string;

export const getStravaAuthUrl = () => {
  const authUrl = new URL("https://www.strava.com/oauth/authorize");
  authUrl.searchParams.append("client_id", clientId);
  authUrl.searchParams.append("response_type", "code");
  authUrl.searchParams.append("redirect_uri", redirectUri);
  authUrl.searchParams.append("scope", "read_all,activity:read_all,profile:read_all");

  return authUrl.toString();
};

// You can add more utility functions to handle the authentication process, such as exchanging the authorization code for an access token.
